<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'com_name', 'custom_date', 'rank', 'writer_name', 'department']"
      :typeslabel="{ custom_date: '계약체결일' }"
    />

    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 산업안전보건관리비</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>금액(천원)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
        <comma-input v-else v-model="form.inputA_1" :readonly="board.readonly" />
      </div>
    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly" title="파일첨부(계약서, 점검실적)"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import DateSelector from '@/components/selector/DateSelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    DateSelector,
    FileUploadModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },

  data () {
    return {
      form: {
        stdInfo:{},
        fileList: [],
        inputA_1: '',
      },
    }
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>

<style scoped>

</style>
